export default __webpack_public_path__ + "static/media/profile.f65c29d7.png";